import { batch, signal } from "@preact/signals-react"


export const retailers = signal([])
export const sections = signal([])

export const selectedRetailerId = signal(null)
export const selectedSectionId = signal(null)
export const selectedDate = signal(new Date().toISOString().slice(0, 10))

export const sessionData = signal(null)        // { fullpage_screenshot, banners[], viewport, page_height, ... }
export const isLoading = signal(false)
export const errorMsg = signal(null)
export const focusedBannerIdx = signal(null)   // selected card / overlay

// Newsletter sections produce N tasks per (section, date) — one per jpg.
// `newsletterAssets` caches the /assets response; `selectedAssetPath` is the
// jpg the admin picked from the chooser. Both are null/empty for `web` sections.
export const newsletterAssets = signal([])     // [{ asset_path, status, id_task, ... }]
export const selectedAssetPath = signal(null)
export const isLoadingAssets = signal(false)

// Edit state. Two modes:
//   - Individual: editingBannerIds holds the id(s) the QA opened by clicking
//     a card's Edit button. Each such card shows its own Save/Cancel.
//   - editAllMode = true: every banner is editable at once and only the
//     header buttons "Save all" / "Cancel all" are visible.
// editDrafts maps id → deep-cloned banner.
export const editingBannerIds = signal(new Set())
export const editDrafts = signal(new Map())
export const editAllMode = signal(false)
export const isSavingEdit = signal(false)

// Brand catalogue cached in memory (fetched from the public Puig endpoint).
export const brandCatalogue = signal(null)

// Lightbox: when set, a full-screen overlay shows the image at max size.
// `lightboxSrc` accepts either a string (single image) or an object
//   { sources: [src1, src2, ...], index: 0 }
// for multi-image groups (sliders, brand-logos, …) where the user can page
// forward/backward.
export const lightboxSrc = signal(null)

// QA filter: when on, only render groups whose parent (single-shot) or
// any sub-item (carousel) has ai_review.needs_qa=true. Sub-items inside
// a visible carousel group are still all rendered — the per-sub-item
// border highlight is enough to spot the ones that need attention.
export const onlyNeedsQa = signal(false)


export const clearReviewSignals = () => batch(() => {
	retailers.value = []
	sections.value = []
	selectedRetailerId.value = null
	selectedSectionId.value = null
	selectedDate.value = new Date().toISOString().slice(0, 10)
	sessionData.value = null
	isLoading.value = false
	errorMsg.value = null
	focusedBannerIdx.value = null
	editingBannerIds.value = new Set()
	editDrafts.value = new Map()
	editAllMode.value = false
	isSavingEdit.value = false
	lightboxSrc.value = null
	newsletterAssets.value = []
	selectedAssetPath.value = null
	isLoadingAssets.value = false
	onlyNeedsQa.value = false
})
